import Rewards from 'components/Rewards/Rewards';
import withRewardsProps from 'viewModel/reward/rewards/withRewardsProps';

const ConnectedRewards = withRewardsProps(Rewards);

export default ConnectedRewards;
